<div class="dashboard-menu-container">
  <ng-content></ng-content>
  <ul *ngIf="showMenu" role="menu" (blur)="handleBlur($event)">
    <li *ngFor="let option of menuOptions; index as i">
      <!-- sort options -->
      <button *ngIf="option.type === menuItemTypeEnum.Sort"
        tabindex="-1" sharedMyButton type="button" role="menuitem"
        (keydown)="resetMenuFocus($event, i, true, option.command)"
        (click)="toggleShowMenu($event, {command: option.command})">
        <i aria-hidden="true" [ngClass]="option.icon"></i>
        <span>{{option.label}}</span>
      </button>
      <!-- filter options -->
      <button sharedMyButton *ngIf="option.type === menuItemTypeEnum.Filter"
        class="checkbox-wrapper dropdown-menu"
        (click)="onCbChange($event, i, option)"
        (keydown)="onCbChange($event, i, option)">
        <div class="checkbox-flex-container">
          <label [class.checked]="option.checked">
            <i *ngIf="option.checked" class="eleot-icon icon-check" aria-hidden="true"></i>
          </label>
          <span aria-hidden="true" class="checkbox-label">{{option.label}}</span>
        </div>
      </button>
      <!-- separators -->
      <div sharedMyButton class="separator" *ngIf="option.type === menuItemTypeEnum.Separator"></div>
    </li>
  </ul>
</div>
